import { render, staticRenderFns } from "./BlockEditModal.vue?vue&type=template&id=18fc3154&scoped=true"
import script from "./BlockEditModal.vue?vue&type=script&lang=js"
export * from "./BlockEditModal.vue?vue&type=script&lang=js"
import style0 from "./BlockEditModal.vue?vue&type=style&index=0&id=18fc3154&prod&scoped=true&lang=css"
import style1 from "./BlockEditModal.vue?vue&type=style&index=1&id=18fc3154&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc3154",
  null
  
)

export default component.exports